import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  backdrop: {
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalPaper: {
    padding: 20,
    backgroundColor: 'white',
    alignSelf: 'center',
    width: '90%',
    maxHeight: '90%',
    overflowY: 'auto',
    maxWidth: 570,
    outline: 'none',
    borderRadius: 10,
  },
  modalHeader: {
    display: 'flex',
    flexDirection: 'row',
  },
  modalHeaderSides: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  modalHeaderCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 3,
  },
  modalHeaderClose: {
    justifyContent: 'flex-end',
  },
  modalHeaderBack: {
    width: '15px !important',
    height: 15,
  },
}));
